import { DebugState } from "./debugTypes";

export const initialState: DebugState = {
  debug_info: [],
};
